import moment from 'moment';

/** Age since purchase as "2y 3m" / "5m" / "12d"; '' when the date is missing or in the future. */
export const assetAge = (purchaseDate?: string | null): string => {
  if (!purchaseDate) return '';
  const from = moment(purchaseDate);
  if (!from.isValid()) return '';
  const now = moment();
  if (from.isAfter(now)) return '';
  const years = now.diff(from, 'years');
  const months = now.clone().subtract(years, 'years').diff(from, 'months');
  if (years > 0) return months > 0 ? `${years}y ${months}m` : `${years}y`;
  if (months > 0) return `${months}m`;
  return `${now.diff(from, 'days')}d`;
};
